export const SHOW_ACCESS_DENIED = "SHOW_ACCESS_DENIED";
export const CLEAR_ACCESS_DENIED = "CLEAR_ACCESS_DENIED";
export const SHOW_NO_PERMISSION = "SHOW_NO_PERMISSION";
export const CLEAR_NO_PERMISSION = "CLEAR_NO_PERMISSION";

export const showAccessDenied = () => ({
	type: SHOW_ACCESS_DENIED,
});

export const clearAccessDenied = () => ({
	type: CLEAR_ACCESS_DENIED,
});

export const showNoPermission = () => ({
	type: SHOW_NO_PERMISSION,
});

export const clearNoPermission = () => ({
	type: CLEAR_NO_PERMISSION,
});
